import clsx, { type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * Compose Tailwind class strings with conflict resolution.
 *
 * Use this anywhere multiple class sources combine - especially when accepting
 * a `className` prop on a component that has its own default classes.
 *
 *   cn("px-4 py-2", isActive && "bg-primary", className)
 *
 * `tailwind-merge` strips conflicts: `cn("px-4", "px-6")` returns `"px-6"`.
 * Without it, both classes ship and Tailwind's last-wins via specificity is
 * fragile (order-dependent).
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
